/**
 * Takes a decimal and converts it into a percentage.
 */
export function decimalToPercentage(value: number): number {
  return value * 100;
}

/**
 * Returns the value if it is in between min and max.
 * Otherwise, returns min or max.
 */
export function enforceIntoRange(
  min: number,
  value: number,
  max: number
): number {
  return Math.min(Math.max(min, value), max);
}

/**
 * Enforce a number to be zero or bigger
 */
export function nonNegative(value: number): number {
  return Math.max(0, value);
}

/**
 * Enforce a number to be zero or smaller
 */
export function nonPositive(value: number): number {
  return Math.min(value, 0);
}

/**
 * Enforce a maximum number of decimal places, minimum of 0 and maximum of 10
 */
export function limitDecimalPlaces(
  value: number,
  decimalPlaces: number
): number {
  const precision = Math.min(nonNegative(decimalPlaces), 10);
  const roundedValue = value.toFixed(precision);
  return Number(roundedValue);
}

/**
 * Returns a random integer between min and max (inclusive).
 */
export function getRandom(min: number, max: number): number {
  if (min > max) {
    throw new Error(
      'Wrong arguments. The first argument must be lower than the second'
    );
  }
  return min + Math.floor(Math.random() * (max - min + 1));
}
